//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      direction: state => state.vux.direction,
    })
  }
}



// WEBPACK FOOTER //
// ./src/App.vue